import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '../../../../../../common/Icons/Search.svg';
import defaultStyles from './StringPillModal.module.scss';

class StringPillModal extends Component {
    // eslint-disable-next-line
    calculateValue(formState) {
        return formState.searchTerm;
    }

    // eslint-disable-next-line
    calculateValueIsBlank(formState) {
        return formState.searchTerm === '';
    }

    componentDidMount() {
        const form = { searchTerm: this.props.value || '' };
        this.props.setUpState(
            this.calculateValue(form),
            form,
            this.props.value === ''
        );
    }

    componentWillUnmount() {
        this.props.resetFilter();
    }

    getEmptyValues() {
        return {
            value: this.calculateValue({ searchTerm: '' }),
            form: {
                searchTerm: ''
            }
        };
    }

    render() {
        return (
            <div className={ this.props.styles.searchInput }>
                <input
                    className={ this.props.styles.input }
                    type="text"
                    name={ `string-${this.props.filter.title}-searchTerm` }
                    valuename="searchTerm"
                    placeholder={ `Search ${this.props.filter.title}` }
                    onChange={ this.props.handleChange }
                    value={ this.props.value }
                />
                <img className={ this.props.styles.img } src={ SearchIcon } alt="" />
            </div>
        );
    }
}

StringPillModal.propTypes = {
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string
    }),
    value: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    setUpState: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

StringPillModal.defaultProps = {
    filter: {
        value: ''
    },
    value: '',
    styles: defaultStyles
};

export default StringPillModal;
